(function () {
  const initializedSections = new WeakSet();
  const upgradeTranslationKeys = [
    'medium_satchel',
    'mini_barrel',
    'medium_backpack',
    'backpack_satchel',
    'washbag',
    'mini_leather_satchel',
    'medium_leather_satchel',
  ];
  const informationTranslationKeys = ['harris_tweed', 'protected_by_law', 'care_instructions'];

  function parseJson(node, message) {
    if (!node) return null;

    try {
      return JSON.parse(node.textContent);
    } catch (error) {
      console.error(message, error);
      return null;
    }
  }

  function applyEditorConfiguration(translations, configuration) {
    if (!configuration) return translations;

    return Object.fromEntries(
      Object.entries(translations).map(([languageCode, language]) => {
        const localizedUpgradeNames = new Map(
          (language.upgrades || []).map((upgrade, index) => [upgradeTranslationKeys[index], upgrade.name])
        );
        const localizedInformation = new Map(
          (language.sections || []).map((item, index) => [informationTranslationKeys[index], item])
        );
        const configuredLanguage = { ...language };

        if (languageCode === 'en' && configuration.header) {
          Object.assign(configuredLanguage, configuration.header);
        }

        if (configuration.upgrades?.length) {
          configuredLanguage.upgrades = configuration.upgrades.map((upgrade) => ({
            name:
              languageCode === 'en'
                ? upgrade.name
                : localizedUpgradeNames.get(upgrade.key) || upgrade.name,
            price: upgrade.price,
          }));
        }

        if (configuration.sections?.length) {
          configuredLanguage.sections = configuration.sections.map((item) => {
            const localizedItem = localizedInformation.get(item.key);

            return {
              title: languageCode === 'en' ? item.title : localizedItem?.title || item.title,
              body: languageCode === 'en' ? item.body : localizedItem?.body || item.body,
            };
          });
        }

        return [languageCode, configuredLanguage];
      })
    );
  }

  function initWorkshopLanguageCards(section) {
    if (!section || initializedSections.has(section)) return;

    const select = section.querySelector('[data-workshop-language-select]');
    const languageLabelNode = section.querySelector('[data-workshop-language-label]');
    const languageDataNode = section.querySelector('[data-workshop-language-data]');
    const configurationNode = section.querySelector('[data-workshop-editor-configuration]');
    const titleNode = section.querySelector('[data-workshop-title]');
    const eyebrowNode = section.querySelector('[data-workshop-eyebrow]');
    const introNode = section.querySelector('[data-workshop-intro]');
    const upgradesHeadingNode = section.querySelector('[data-workshop-upgrades-heading]');
    const upgradesCopyNode = section.querySelector('[data-workshop-upgrades-copy]');
    const upgradesLabelNode = section.querySelector('[data-workshop-upgrades-label]');
    const baseProductLabelNode = section.querySelector('[data-workshop-base-product-label]');
    const upgradeNameNodes = section.querySelectorAll('[data-workshop-upgrade-name]');
    const upgradePriceNodes = section.querySelectorAll('[data-workshop-upgrade-price]');
    const mobileBaseProductLabelNodes = section.querySelectorAll('[data-workshop-mobile-base-product-label]');
    const mobileUpgradeNameNodes = section.querySelectorAll('[data-workshop-mobile-upgrade-name]');
    const mobileUpgradePriceNodes = section.querySelectorAll('[data-workshop-mobile-upgrade-price]');
    const informationTitleNodes = section.querySelectorAll('[data-workshop-information-title]');
    const informationBodyNodes = section.querySelectorAll('[data-workshop-information-body]');

    if (
      !languageDataNode ||
      !titleNode ||
      !eyebrowNode ||
      !introNode ||
      !upgradesHeadingNode ||
      !upgradesCopyNode ||
      !upgradesLabelNode ||
      !baseProductLabelNode
    ) {
      return;
    }

    const translations = parseJson(languageDataNode, 'Workshop language data could not be loaded.');
    const configuration = parseJson(configurationNode, 'Workshop editor settings could not be loaded.');

    if (!translations) return;

    const configuredTranslations = applyEditorConfiguration(translations, configuration);
    const storageKey = `workshop-language:${section.dataset.sectionId || 'default'}`;

    const renderLanguage = (languageCode) => {
      const language = configuredTranslations[languageCode] || configuredTranslations.en;
      if (!language) return;

      if (select) select.value = languageCode;
      if (languageLabelNode && language.languageLabel) {
        languageLabelNode.textContent = language.languageLabel;
      }

      eyebrowNode.textContent = language.eyebrow;
      titleNode.innerHTML = language.title;
      introNode.innerHTML = language.intro;
      upgradesHeadingNode.textContent = language.upgradesHeading;
      upgradesCopyNode.innerHTML = language.upgradesCopy;
      upgradesLabelNode.textContent = language.upgradesLabel;
      baseProductLabelNode.textContent = language.baseProductLabel;

      upgradeNameNodes.forEach((node, index) => {
        const upgrade = language.upgrades[index];
        if (upgrade) node.textContent = upgrade.name;
      });

      upgradePriceNodes.forEach((node, index) => {
        const upgrade = language.upgrades[index];
        if (upgrade) node.textContent = upgrade.price;
      });

      mobileBaseProductLabelNodes.forEach((node) => {
        node.textContent = language.baseProductLabel;
      });

      mobileUpgradeNameNodes.forEach((node, index) => {
        const upgrade = language.upgrades[index];
        if (upgrade) node.textContent = upgrade.name;
      });

      mobileUpgradePriceNodes.forEach((node, index) => {
        const upgrade = language.upgrades[index];
        if (upgrade) node.textContent = upgrade.price;
      });

      informationTitleNodes.forEach((node, index) => {
        const item = language.sections[index];
        if (item) node.textContent = item.title;
      });

      informationBodyNodes.forEach((node, index) => {
        const item = language.sections[index];
        if (item) node.innerHTML = item.body;
      });

      window.localStorage.setItem(storageKey, languageCode);
    };

    const savedLanguage = window.localStorage.getItem(storageKey);
    const initialLanguage = configuredTranslations[savedLanguage] ? savedLanguage : select?.value || 'en';

    renderLanguage(initialLanguage);

    select?.addEventListener('change', (event) => {
      renderLanguage(event.target.value);
    });

    initializedSections.add(section);
  }

  function initWorkshopLanguageCardsInRoot(root) {
    if (!root) return;

    if (root.matches?.('[data-workshop-language-cards]')) {
      initWorkshopLanguageCards(root);
      return;
    }

    root.querySelectorAll('[data-workshop-language-cards]').forEach(initWorkshopLanguageCards);
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        initWorkshopLanguageCardsInRoot(document);
      },
      { once: true }
    );
  } else {
    initWorkshopLanguageCardsInRoot(document);
  }

  document.addEventListener('shopify:section:load', (event) => {
    initWorkshopLanguageCardsInRoot(event.target);
  });
})();
